<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1><span style="font-size:20pt;">A</span>cknowledgement</h1>
<p style="text-align:center;">Thank you to Stewart Simpson for inspiring me to love reading.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?5f1ad94a